import script from "./ArticleForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleForm.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleForm.vue?vue&type=style&index=0&id=846cbfc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-846cbfc2"]])

export default __exports__